import React, { Component } from 'react';
import AppButton from './AppButton';
import { Address } from './Address'
import { SpeechBubble } from './SpeechBubble'
import queryString from 'query-string'
import AuthService from "../services/AuthService";
import UtilService from "../services/UtilService";

export class PaymentResult extends Component {
    static displayName = PaymentResult.name;

    constructor(props) {
        super(props);
        const { match: { params, search } } = this.props;
        this.state = {
            loaded: false,
            notFound: false,
            to: {   
                Address: {
                    Id: 0, 
                    Addr: null,
                    address_type: {description: "", value: ""},
                    suburb: { name: "", pcode: "", depot: { code:"", name:""} }, 
                    Address1: "", 
                    Address2: "",
                    Name: ""
                },
                Contact: {
                    Name: "",
                    Mobile : "",
                    Email: ""
                },             
                Instruction: ""
            },
            shipment: {
                connote: "",
                status: 0,
                from: {},
                to: {}
            },
            offer: {
                offers: [{}]                
            },
            AdditionalServices: [],
            token: (params || {jobid: null}).jobid,
            params: params || {jobid: null},
            busy: true,
            authenticatedUser: null,
            RedirectionServices: []
        };
    }

    async componentDidMount() {                
        const qs = queryString.parse(this.props.location.search);  
        var offerTask = this.loadOffer();
        var getResult = this.loadResult(qs.s);
        await offerTask;
        await getResult;

        this.authService = await AuthService.getInstance();
    }

    async loadResult(paymentSessionId){
        // if there's a session id load the payment request - the paid items are the ones that had a price provided it was successful
        // else get the list of possible additional services for this offer
        if(paymentSessionId != null) {
            var sessionResult = await (await window.fetch(`api/offer/${this.state.params.jobid}/paymentdetail/${paymentSessionId}`)).json();     
            console.log('sessionResult', sessionResult);
            this.setState({paymentResult: sessionResult.paymentResult});
            if(sessionResult.fmeError) 
                this.setState({fmeError: sessionResult.fmeError});
            // when there is only a single element it is returned as a single object not array - something to do with Json to XML and back
            var services = (sessionResult.services && sessionResult.services.length) ? sessionResult.services : [];
            var redirectionServices = (sessionResult.redirectionServices && sessionResult.redirectionServices.length) ? sessionResult.redirectionServices : [];
            this.setState({AdditionalServices: services || [], RedirectionServices: redirectionServices, acceptTerms: true});
        }
    }

    async loadOffer() {
        let offer = await (await window.fetch('api/offer/' + this.state.params.jobid)).json();
        this.setOffer(offer);
        this.setState({busy: false});
        return offer;
    }

    redirectPrice = () => {
        return this.state.RedirectionServices.reduce && this.state.RedirectionServices.reduce((sum, service) => sum + parseFloat(service.priceInclGST),0.0);
    }

    additionalServicePrice = () => {
        return this.state.AdditionalServices.reduce && this.state.AdditionalServices.reduce((sum, service) => sum + (service.justpaid === true ? parseFloat(service.priceInclGST)||0 : 0.0),0.0);
    }

    totalPrice = () =>  {
        return `$${UtilService.roundMoneyTo((this.additionalServicePrice() + this.redirectPrice()), 2)}`;
    }

    setOffer(newOffer) {
        //console.log('offer details', newOffer);
        if (newOffer.location){
            this.setState({location: newOffer.location});
        }
        if (newOffer.shipment){
            this.setState({shipment: newOffer.shipment});
        }
        if (newOffer.offer){
            this.setState({offer: newOffer.offer});
        }
        else if (newOffer.status === 404) {
            this.setState({
                notFound: true
            });
        }
    }

    postData(url = '', data = {}, idToken = null) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if(idToken)
            headers.append('Authorization', `Bearer ${idToken}`);

        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: headers,
            redirect: 'follow',
            referrer: 'no-referrer',
            body: JSON.stringify(data),
        })
        .then(response => {
            if(!response.ok) {
                if(response.status == "409"){
                    alert("Sorry this is out of date; Tap to refresh.");
                    return this.loadOffer();
                }
                if(response.status == "401"){
                    alert("Please login or register to do this.");
                    return null;
                }
                else{
                    alert("Error: " + response.statusText);
                }
            }
            return response.json();
        });
    }

    getPaymentMessage() {
        if(this.state.paymentResult === "approved"){            
            if(this.state.fmeError) {
                return <SpeechBubble content={<React.Fragment><span>UNEXPECTED ERROR</span><br />
                    <span className="small">Sorry there was an error processing your change of address.<br/>Please contact us.</span></React.Fragment>} />;
            }
            else if(this.totalPrice() === "$0.00") {
                if(this.state.AdditionalServices && this.state.AdditionalServices.length > 0) {
                    return <SpeechBubble content={<React.Fragment><span>CHANGE CONFIRMED</span><br />
                        <span className="small">Thanks, we've added your additional services</span></React.Fragment>} />;    
                }                
                return <SpeechBubble content={<React.Fragment><span>CHANGE CONFIRMED</span><br />
                    <span className="small">Thanks, we've got your new delivery address</span></React.Fragment>} />;
            }
            else{
                return <SpeechBubble content={<React.Fragment><span>PAYMENT SUCCESSFUL</span><br />
                    <span className="small">Thank you for your payment</span></React.Fragment>} />;
            }
        }
        else if(this.state.paymentResult != null && this.state.paymentResult !== "approved")
                return <SpeechBubble content={<React.Fragment><span>PAYMENT FAILED</span><br />
                    <span className="small">Sorry something went wrong with your payment. Please try again.</span></React.Fragment>} />;
        else
            return <div style={{marginTop: "0.4em"}} />;
    }

    render() {
        return (
            this.state.notFound === true ?
            <div>
                <div className="header">My Delivery: NOT FOUND</div>
                <div style={{textAlign: "center"}}>Shipment Not Found</div>
            </div> :
                <div className="additional-services">
                    <div className="header">My Delivery: {this.totalPrice() === "$0.00" ? "CONFIRMED" : "PAYMENT"}</div>
                    {this.state.busy && <div>Loading...</div>}
                    {!this.state.busy &&
                    <div>
                    <div className="view-body">    
                        <div className="edit-icon-right">                              
                            <Address label="We have a parcel for you from" address={{line1: this.state.shipment.from.line1}} />
                            <div><i className="icon-x-app-icon connote"></i></div>
                        </div>
                        <Address label="Your delivery address" address={this.state.shipment.to} />                    
                        {this.getPaymentMessage()}
                        {(this.state.RedirectionServices && this.state.RedirectionServices.length > 0 && this.redirectPrice() >0) && 
                        <div>
                            <div className="header">Change Address Costs</div>
                            <table className="services">
                                <tbody>
                                    {this.state.RedirectionServices.map((rc) => 
                                        <tr key={rc.code}>
                                            <td style={{width: "100%"}}>{rc.description}</td>
                                            <td>{(rc.priceInclGST && '$' + UtilService.roundMoneyTo(parseFloat(rc.priceInclGST||0), 2))}</td>
                                        </tr>)}
                                </tbody>
                            </table>
                        </div>}
                        {(this.state.AdditionalServices && this.state.AdditionalServices.length > 0) && 
                        <div>
                            <div className="header">Additional Services</div>                        
                            <table className="services">
                                <tbody>
                                    {this.state.AdditionalServices.map((as) => 
                                        <tr key={as.code}>
                                            <td><input type="checkbox" className="large" defaultChecked={as.selected} disabled /></td>
                                            <td style={{width: "100%"}}>{as.description}</td>
                                            <td>{((as.justpaid) && ('$' + UtilService.roundMoneyTo(parseFloat(as.priceInclGST||0),2)))}</td>
                                        </tr>)}
                                </tbody>
                            </table>
                        </div>}
                        <div>
                            {(this.redirectPrice() > 0 || (this.state.AdditionalServices && this.state.AdditionalServices.length > 0)) &&
                            <div className="header">Total Price (incl. GST)<div style={{float: "right"}}>{this.totalPrice()}&nbsp;</div></div>}
                        </div>
                        <div className="action-area">
                            <div className="clearfix">
                                <AppButton function iconName="icon-function-left-arrow-up" actionText="Back" 
                                    onClick={() => { this.props.history.push('/shipments')  }} footer="Return to your jobs"/>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
        );
    }
}
